import React from 'react'
import { Box } from 'grommet'

const MenuIcon = ({ icon, size = '1.8rem' }) => {
  return (
    <Box
      align="center"
      justify="center"
      alignSelf="center"
      width={size}
      height={size}
      margin={{ left: '.3rem', right: '1.2rem' }}
    >
      {icon}
    </Box>
  )
}
export default MenuIcon
